import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import {
  TraceabilityRequests,
  TraceabilityResponses,
} from "@tfg/types/endpoints/traceability"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

interface EditProductionSiteVariables {
  request: TraceabilityRequests.EditProductionSite
}

export const useEditProductionSiteMutation = (
  productionSiteId: string,
  options?: UseMutationOptions<
    TraceabilityResponses.ProductionSite,
    AxiosError,
    EditProductionSiteVariables
  >
) => {
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      const res = (
        await httpClient.put<TraceabilityResponses.ProductionSite>(
          `/production-sites/${productionSiteId}`,
          variables.request
        )
      ).data
      return res
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["listProductionSites"])
    },
  })
}
